import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FlagGroupService } from '../../flag/flag.group.service';
import { FlagGroupTag, Inspection } from '../../shared/interfaces';
import { FlagGroupTemplateComponent } from '../flag-group-template/flag-group-template.component';

@Component({
  selector: 'app-add-group',
  templateUrl: './add.group.component.html',
  styleUrls: ['./add.group.component.scss'],
})
export class AddGroupComponent implements OnInit {
  form: UntypedFormGroup;
  @Output() groupAdded = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();
  @Input() inspection: Inspection;
  @Input() flagGroupTags: FlagGroupTag[] = [];
  @ViewChild('flagGroupTemplateModal', { static: true }) public flagGroupTemplateModal: FlagGroupTemplateComponent;
  saving = false;
  allFlagGroups = [];

  constructor(
    private flagGroupService: FlagGroupService,
    private fb: UntypedFormBuilder,
  ) {}

  async ngOnInit() {
    this.form = this.fb.group({
      name: ['', [Validators.required, this.groupNameValidator.bind(this)]],
    });

    const [allFlagManagerGroupTags] = await this.flagGroupService.listByInspection(this.inspection.id);
    this.allFlagGroups = allFlagManagerGroupTags;
  }

  groupNameValidator(control: AbstractControl): { [key: string]: any } | null {
    if (this.form) {
      const groupName = control.value || '';
      const groupExistWithOtherSubtype = this.allFlagGroups.find(g => g.name.toUpperCase() === groupName.toUpperCase());
      if (groupExistWithOtherSubtype) {
        return { flagGroupExists: { value: control.value } };
      }
    }
    return null;
  }

  async save() {
    if (this.saving) return;

    if (this.form.invalid) return;

    this.saving = true;

    try {
      const formData = this.form.value;
      const group = await this.flagGroupService.create(this.inspection.id, formData);
      this.groupAdded.emit(group);
    } catch (err) {
      console.error('Error saving group', err);
    } finally {
      this.saving = false;
    }
  }

  getValidationClass(field: string) {
    const control = this.form.get(field);
    return {
      'is-valid': control.valid && (control.dirty || control.touched),
      'is-invalid': control.invalid && (control.dirty || control.touched),
    };
  }

  applyTemplate() {
    this.flagGroupTemplateModal.show();
  }

  updateData(group) {
    this.saving = false;
    this.groupAdded.emit(group);
  }
}
